import { useState } from "react";

import iSearch from "../../assets/images/100-search.svg";
import img1 from "../../assets/tutorial-items/i1.svg";
import img2 from "../../assets/tutorial-items/i2.svg";
import img3 from "../../assets/tutorial-items/i3.svg";

const SearchBox = ({ placeholder }) => {
  const [searchValue, setSarchValue] = useState("");

  const [loadingPage, setLoadingPage] = useState(true);

  setTimeout(() => {
    setLoadingPage(false);
  }, 1000);

  return loadingPage ? (
    <div className="loading-search-box">
      <div className="loading-320-36-4 loading-animation" />
    </div>
  ) : (
    <div className="search-box">
      <div className="search-box__container">
        <div className="search-box__input">
          <input type="search" placeholder={`Search ${placeholder}`} value={searchValue} onChange={(e) => setSarchValue(e.target.value)} />
        </div>
        <div className="flex">
          <img alt="" src={iSearch} className="i-search i-16 pointer" />
        </div>
      </div>
      {searchValue.length > 1 && (
        <div className="search-box__result">
          <ul className="m-tb-10">
            <li className="space-between">
              <div className="align-items-center w-100p">
                <img alt="" src={img1} />
                <span>Firefox Clear Cache</span>
                <span className="search-box__result-close"> X </span>
              </div>
            </li>
            <li className="space-between">
              <div className="align-items-center w-100p">
                <img alt="" src={img2} />
                <span>Firefox Clear Cache</span>
                <span className="search-box__result-close"> X </span>
              </div>
            </li>
            <li className="space-between">
              <div className="align-items-center w-100p">
                <img alt="" src={img3} />
                <span>Firefox Clear Cache</span>
                <span className="search-box__result-close"> X </span>
              </div>
            </li>
            <li className="space-between">
              <div className="align-items-center w-100p">
                <img alt="" src={img1} />
                <span>Firefox Clear Cache</span>
                <span className="search-box__result-close"> X </span>
              </div>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
export default SearchBox;
